import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { format } from "date-fns";
import { Filter, IFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { startOfMonth, endOfMonth } from "date-fns";

interface Iprops {
    toast: any,
    reload: boolean,
    reloadData: () => void,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({
        data: [],
        count: 0,
        loading: false
    });

    const [text, setText] = useState<string | null>(null);

    const dt = useRef<any>(null);
    const [leadDialog, setLeadDialog] = useState(false);
    const [leadData, setLeadData] = useState<any[]>([]);
    const [leadLoading, setLeadLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: "userId",
        sortOrder: -1
    });
    const now = new Date();
    const [filter, setFilter] = useState<IFilter>({
        fromDate: startOfMonth(now),
        toDate: new Date()

    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload, filter]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const loadTableData = async () => {
        if (filter.fromDate && filter.toDate) {
            const from = new Date(filter.fromDate);
            const to = new Date(filter.toDate);
            from.setHours(0, 0, 0, 0);
            to.setHours(0, 0, 0, 0);
            if (to < from) {
                props.toast.current.show({
                    severity: "warn",
                    summary: "Date Error",
                    detail: "To Date must be greater than or equal to From Date",
                    life: 3000
                });
                return;
            }
        }
        setTableData((prev: any) => ({ ...prev, loading: true }));

        const query =
            `lazyParams=${JSON.stringify(lazyParams)}` +
            `${text ? "&text=" + text : ""}` +
            `${filter.name ? "&name=" + filter.name : ""}` +
            `${filter.fromDate ? "&fromDate=" + format(filter.fromDate, "yyyy-MM-dd") : ""}` +
            `${filter.toDate ? "&toDate=" + format(filter.toDate, "yyyy-MM-dd") : ""}`;

        const response = await Fetch("User/leadReport", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({
                data: data.users,
                count: data.count,
                loading: false
            });
        }
        else {
            setTableData((prev: any) => ({ ...prev, loading: false }));
        }
    };


    const loadLeadDetails = async (userId: number, statusId: number) => {
        if (filter.fromDate && filter.toDate) {
            const from = new Date(filter.fromDate);
            const to = new Date(filter.toDate);
            from.setHours(0, 0, 0, 0);
            to.setHours(0, 0, 0, 0);
            if (to < from) {
                props.toast.current.show({
                    severity: "warn",
                    summary: "Date Error",
                    detail: "To Date must be greater than or equal to From Date",
                    life: 3000
                });
                return;
            }
        }
        setLeadDialog(true);
        setLeadLoading(true);
        const query =
            `userId=${userId}` +
            `&statusId=${statusId}` +
            `${filter.fromDate ? "&fromDate=" + format(filter.fromDate, "yyyy-MM-dd") : ""}` +
            `${filter.toDate ? "&toDate=" + format(filter.toDate, "yyyy-MM-dd") : ""}`;
        const response = await Fetch("User/getLeadDetails", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setLeadData(data);
        }
        setLeadLoading(false);
    };

    const clickableBody = (field: string, statusId: number) => {
        return (rowData: any) => {
            const value = rowData[field];

            return (
                <span
                    style={{
                        cursor: value > 0 ? "pointer" : "default",
                        color: value > 0 ? "#2563eb" : "#6b7280",
                        fontWeight: 600
                    }}
                    onClick={() => {
                        if (value > 0) {
                            loadLeadDetails(rowData.userId, statusId);
                        }
                    }}
                >
                    {value}
                </span>
            );
        };
    };



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">

            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: "uppercase", letterSpacing: 1 }}>
                        Lead Progress Report
                    </h4>
                </div>
            </div>

            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
            </div>

        </div>
    );

    const calculateTotal = (field: string) => {
        let total = 0;
        if (tableData.data) {
            tableData.data.forEach((item: any) => {
                total += (item[field] || 0);
            });
        }
        return total;
    };

    return (
        <>

            <Filter
                header={<div>Filter</div>}
                loading={tableData.loading}
                filter={filter}
                setFilter={setFilter}
            />

            <DataTable
                style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
                ref={dt}
                size="small"
                stripedRows
                showGridlines
                responsiveLayout="scroll"
                scrollHeight="75vh"
                value={tableData.data}
                lazy
                dataKey="userId"
                paginator
                first={lazyParams.first}
                rows={lazyParams.rows}
                rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count}
                onPage={onPage}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
                emptyMessage="No Lead Report found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} footer="TOTAL" />
                <Column field="name" header="Name" />
                <Column field="email" header="Email" />
                <Column field="totalLeads" header="Total Leads" body={clickableBody("totalLeads", 0)} footer={calculateTotal("totalLeads")} />
                <Column field="created" header="Created" body={clickableBody("created", 5)} footer={calculateTotal("created")} />
                <Column field="calling" header="Calling" body={clickableBody("calling", 1)} footer={calculateTotal("calling")} />
                <Column field="interested" header="Interested" body={clickableBody("interested", 3)} footer={calculateTotal("interested")} />
                <Column field="activated" header="Activated" body={clickableBody("activated", 4)} footer={calculateTotal("activated")} />
                <Column field="convertedToSales" header="Converted To Sales" body={clickableBody("convertedToSales", 4)} footer={calculateTotal("convertedToSales")} />
                <Column field="notInterested" header="Not Interested" body={clickableBody("notInterested", 6)} footer={calculateTotal("notInterested")} />
            </DataTable>

            <Dialog
                header="Lead Details"
                visible={leadDialog}
                style={{ width: "70vw" }}
                onHide={() => setLeadDialog(false)}
            >

                <DataTable
                    value={leadData}
                    loading={leadLoading}
                    stripedRows
                    size="small"
                    scrollable
                    scrollHeight="60vh"
                    emptyMessage="No Leads Found"
                >
                    <Column field="name" header="Name" />
                    <Column field="email" header="Email" />
                    <Column field="phone" header="Phone" />
                    <Column field="status" header="Status" />
                    {/* <Column field="createdDate" header="Created Date" /> */}
                </DataTable>

            </Dialog>



        </>
    );
};